import React from 'react';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const InnerContainer = styled.div`
  width: 100%;
  max-width: 1279px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;

  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
  }
`;

const WidthContainer = ({ children }) => {
  return (
    <Container>
      <InnerContainer>{children}</InnerContainer>
    </Container>
  );
};

export default WidthContainer;
